import {
  initI18n as baseInit,
  setLocale,
  t,
  type Language,
} from '@bn-games/i18n-core';
import { en } from './locales/en.js';
import { ru } from './locales/ru.js';

export { setLocale, t };

export async function initI18n(lang: Language): Promise<void> {
  await baseInit(lang, { en, ru });
}
